import Vue from 'vue'
import * as VueGoogleMaps from '~/node_modules/vue2-google-maps/src/main'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyC_G69e-c04ABQ7n5RK7MbbfklfmuqWDEY'
  }
})
